var toggleInputContainer = function (input) {
  if (input.value != "") {
      input.classList.add('filled');
  } else {
      input.classList.remove('filled');
  }
}

var labels = document.querySelectorAll('.label');
for (var i = 0; i < labels.length; i++) {
  labels[i].addEventListener('click', function () {
    this.previousElementSibling.closest('input').focus();
  });
}

window.addEventListener('turbolinks:load', function () {
  var inputs = document.getElementsByClassName("input");
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('keyup', function () {
        toggleInputContainer(this);
    });
    toggleInputContainer(inputs[i]);
  }
});
